<template>
    <main>
      <Head>
        <link rel="icon" href="/images/icon.jpeg" type="image/gif" sizes="16x16"/>
        <title>Sultan Fatah - Pendaftaran Online</title>
      </Head>
      <div class="container w-full xl:px-56 pt-2">
        <Contact/>
      </div>
      <div class="container xl:px-56 pb-10">
        <slot/>
        <div v-if="$page.url != '/'" class="w-full md:w-1/2 mx-auto">
          <hr class="mt-5"/>
          <Link @click="back" class="btn-red rounded-3xl mt-2 text-white m-auto w-32 h-14" >
              KEMBALI
          </Link>
      </div>
        <!-- <Link 
            @click="back"
            class="bg-red-600 hover:bg-red-800 text-sm text-white text-center rounded-lg h-12 p-5 flex items-center justify-center mt-5 mr-2 w-32 ml-auto"
            > {{"<- KEMBALI"}}</Link
        > -->
      </div>
    </main>
  </template>
    
    <script>
    import { Link } from '@inertiajs/inertia-vue3'
    import { Head } from '@inertiajs/inertia-vue3'
    import RandomShape from './RandomShape.vue';
    import Contact from './Contact.vue'
    
    export default {
      components: {
      RandomShape,
      Head,
      Contact,
      Link
  },
  methods: {
      back() {
            window.history.back();
        }
    },
    }
    </script>